import React from "react";
import PropTypes from "prop-types";

function ContentPageImage({ src, altText }) {
  return (
    <div className="text-center mb-40">
      <div className="rimage" style={{ paddingTop: "72.98701298701299%" }}>
        <img
          src={src}
          className="rimage__img rimage__img--fade-in lazyload"
          alt={altText}
        />
      </div>
    </div>
  );
}

ContentPageImage.propTypes = {
  src: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
};

export default ContentPageImage;
